import { purify } from "../../_src/components/purify";

function setActive(btnsArray, element){
    element.classList.toggle("active")

    filterByCategory(false)
}

function filterByCategory(loadmore) {
    let loadMoreButton = document.querySelector("#load-more-archives button")
    let allInputs = Array.from(document.querySelectorAll(".filter-by-tags button.active")).map((el) => el.dataset.category)
    let query = new URLSearchParams();

    const url = window.location.href;
    const urlParams = new URLSearchParams(url.split('?')[1]);
    const paramValue = urlParams.get('param');

    allInputs.forEach((input) => {
        query.append("categoria[]", input)
    })

    let page = 1

    if(loadMoreButton) {
        loadMoreButton.classList.add("loading")
        page = loadMoreButton.dataset.page
    }

    fetch(`/acervo-digital/biblioteca-virtual/ajax/arquivos.html/p${page}?&loadmore=${loadmore}&${query.toString()}&param=${paramValue}`, {
        method: "POST",
    })
    .then((response) => {
        return response.text()
    }).then((data) => {
        if (loadmore) {
            document.querySelector("#load-more-archives").insertAdjacentHTML("beforebegin", data)

            if (parseInt(loadMoreButton.dataset.page) == parseInt(loadMoreButton.dataset.total)) {
                loadMoreButton.remove()
            }
            
            loadMoreButton.dataset.page = parseInt(loadMoreButton.dataset.page) + 1
        } else {
            document.getElementById("result-virtual-library").innerHTML = purify(data)

            let loadMoreButton = document.querySelector("#load-more-archives button")
            loadMoreButton?.addEventListener('click', function() {
                filterByCategory(true)
            });
        }
    }).catch((error) => {
        console.error(error);
    }).finally(() => {
        loadMoreButton?.classList.remove("loading")
    })
}

function filterByText() {
    const form = document.querySelector("#filter-by-text")

    form.addEventListener('submit', function(e) {   
        e.preventDefault()

        var inputValue = form.querySelector('input').value
        var normalizedValue = inputValue.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

        var newURL = window.location.origin + window.location.pathname + '?param=' + encodeURIComponent(normalizedValue).replace(/%20/g, '+');

        location.href = newURL;
    });
}

if(document.querySelector("#container-virtual-library")){
    const filters = document.querySelectorAll(".library-filter")
    const loadMoreButton = document.querySelector("#load-more-archives button")

    filters.forEach(function(element) {
        element.addEventListener('click', function() {
            setActive(filters, element)
          });
    });

    loadMoreButton?.addEventListener('click', function() {
        filterByCategory(true)
    });

    filterByText()
}